//#region libraries
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';

//redux
import { selectAutoAcceptUnplannedTask, setAutoAcceptUnplannedTask } from '_redux/slices/timeline/timeline-control';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

//bootstrap
import { Form } from 'react-bootstrap';

//#endregion

const AutoAcceptUnplannedTask = () => {

  //redux
  const dispatch = useDispatch();
  const autoAcceptUnplannedTask = useSelector(selectAutoAcceptUnplannedTask); // status of auto accept unplaned task switch
  const usedTheme = useSelector(selectUsedTheme);

  return (

    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
          Unplanned tasks auto accept
        </span>
        <Form.Check
          onClick={() => { dispatch(setAutoAcceptUnplannedTask(!autoAcceptUnplannedTask)) }}
          type="switch"
          defaultChecked={autoAcceptUnplannedTask}
          style={{ marginLeft: "16px" }}
        />
      </div>
      <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
        Unplanned tasks created by the employee will be auto accepted
      </span>
    </div>

  )
}

export default AutoAcceptUnplannedTask
